<template>

  <b-form-group v-if="getField(customFieldId).customFieldType === TYPE_INPUT">
    <label
      :for="'customField_'+fieldIndex"
      class="form-control-label">{{ getField(customFieldId).label }}</label>
    <input
      :id="'customField_'+fieldIndex"
      v-model="value"
      class="form-control"
      type="text"
      required="true">
  </b-form-group>

  <b-form-group v-else-if="getField(customFieldId).customFieldType === TYPE_LABEL">
    <label
      :for="'customField_'+fieldIndex"
      class="form-control-label"></label>
    <div>
      {{ getField(customFieldId).label }}
    </div>
  </b-form-group>

  <b-form-group v-else-if="getField(customFieldId).customFieldType === TYPE_SELECT">
    <label
      :for="'customField_'+fieldIndex"
      class="form-control-label"></label>
    <model-select
      :options="JSON.parse(getField(customFieldId).customFieldValues)"
      v-model="value"
    >
    </model-select>
  </b-form-group>

  <b-form-group v-else-if="getField(customFieldId).customFieldType === TYPE_DATE">
    <label
      :for="'customField_'+fieldIndex"
      class="form-control-label"></label>
    <fg-input>
      <el-date-picker
        :picker-options="{firstDayOfWeek: 1}"
        v-model="value"
        type="date"
        default-time="12:00:00">
      </el-date-picker>
    </fg-input>
  </b-form-group>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'CustomField',

  components: {
    ModelSelect
  },

  data () {
    return {
      TYPE_INPUT: 1,
      TYPE_LABEL: 2,
      TYPE_DATE: 3,
      TYPE_SELECT: 4,
      value: ''
    }
  },

  watch: {
    value (val) {
      if (this.getField(this.customFieldId).customFieldType === this.TYPE_DATE) {
        this.$emit('input', this.$moment(val).format('YYYY-MM-DD'))
      } else {
        this.$emit('input', val)
      }
    }
  },

  computed: {
    ...mapGetters({
      customFields: 'customfields/list/items'
    })
  },

  mounted () {
    if (this.customFields.length < 1) {
      this.fetchCustomFields()
    }
    if (this.customFieldInitialValue) {
      this.value = this.customFieldInitialValue
    }
  },

  props: ['customFieldId', 'fieldIndex', 'customFieldInitialValue'],

  methods: {
    getField (id) {
      if (!id) {
        return { customFieldType: 0 }
      } else {
        return this.customFields.find(field => field['@id'] === id)
      }
    },
    ...mapActions({
      fetchCustomFields: 'customfields/list/getItems'
    })
  }
}
</script>

<style scoped>

</style>
